<template>
	<div :class="{ 'border-t border-gray-200': hasReceiptUpsellsAvailable }">
		<template v-if="$flowstore.checkout.meta.upsells.receipt">
			<UpsellReceiptCard
				v-for="product in $flowstore.checkout.meta.upsells.receipt.products"
				:key="product.id"
				:product="product"
			/>
		</template>
	</div>
</template>

<script lang="ts" setup>
import { useFlowStore } from '@/stores/useFlowStore';
import UpsellReceiptCard from '@/components/UpsellReceiptCard.vue';

const { hasReceiptUpsellsAvailable } = useFlowStore();
</script>
